import React from "react";
import { makeStyles } from "@mui/styles";
import { FontSize } from "src/const/font";
import { colors } from "src/colors/colors";

const useStyles = makeStyles((theme) => {
  return {
    styleDefault: {
      fontSize: FontSize.normal.default,
      fontWeight: 400,
      lineHeight: "auto",
      color: theme.custom?.text.title,
      [theme.breakpoints.down("md")]: {
        fontSize: FontSize.normal.p4,
      },
    },
    disabledText: {
      color: colors.text.disabled
    }
  };
});
interface PropsTextDescI {
  style?: React.CSSProperties;
  children: string | any;
  className?: string;
  disabled?: boolean;
}

const TextBase = (props: PropsTextDescI) => {
  const { style, children, className, disabled = false } = props;
  const classes = useStyles();
  //! Render
  return (
    <>
      <p
        className={`${classes.styleDefault} ${disabled && classes.disabledText} ${className}`}
        style={{ ...style }}
      >
        {children}
      </p>
    </>
  );
};
export default TextBase;